// These descriptors describe intent, not verified processing or asset provenance.
export function isEditorialPlayback(video, publicationId) {
  return Boolean(publicationId && video?.kind === "editorial-video" && video.publicationId === publicationId
    && typeof video.id === "string" && video.id && typeof video.title === "string"
    && video.source?.delivery === "progressive" && video.source.processing === "source-only"
    && ["video/mp4", "video/webm"].includes(video.source.type)
    && typeof video.source.src === "string" && video.source.src
    && !Object.hasOwn(video, "advertising") && !Object.hasOwn(video, "campaignId") && !Object.hasOwn(video, "creativeId"));
}

export function isVideoAdvertisingPolicy(policy, publicationId) {
  return Boolean(publicationId && policy?.kind === "video-advertising-policy" && policy.publicationId === publicationId
    && policy.enabled === true && policy.placementId === "home_video" && policy.deliveryStatus === "not-integrated"
    && !Object.hasOwn(policy, "source"));
}
